import React from "react";
import PropTypes from "prop-types";
import BlockRenderer from "./BlockRenderer";

export function RothermelAccountIntelligenceView({
  blocks,
  artifact,
  workspace,
  isInternalUser,
  backLabel,
  onBack
}) {
  if (!blocks?.length) {
    return null;
  }

  return (
    <BlockRenderer
      blocks={blocks}
      artifact={artifact}
      workspace={workspace}
      isInternalUser={isInternalUser}
      backLabel={backLabel}
      onBack={onBack}
    />
  );
}

RothermelAccountIntelligenceView.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.object),
  artifact: PropTypes.object,
  workspace: PropTypes.object,
  isInternalUser: PropTypes.bool,
  backLabel: PropTypes.string,
  onBack: PropTypes.func
};

export default RothermelAccountIntelligenceView;
